export default function SuccessScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="spss-success-screen flex flex-col items-center text-center gap-6 max-w-lg">
        <div className="w-20 h-20 rounded-full bg-white/10 flex items-center justify-center">
          <i className="fa-solid fa-check text-4xl text-white" />
        </div>
        <h1 className="text-3xl desktop:text-5xl font-bold text-white">
          Pendaftaran Berhasil!
        </h1>
        <p className="text-white/50 font-sans text-sm desktop:text-base leading-relaxed">
          Terima kasih telah mendaftar di{" "}
          <strong className="text-white">SPSS 2026</strong>.
          Kami telah menerima pendaftaran Anda dan akan mengirimkan
          email konfirmasi dalam waktu dekat. Nantikan informasi
          selanjutnya!
        </p>
        <div className="flex gap-4 mt-4">
          <a
            href="/"
            className="flex items-center gap-2 px-8 py-3 rounded-xl bg-white text-midnight
              font-sans text-sm font-bold transition-all duration-300 hover:scale-105 hover:shadow-lg"
          >
            <i className="fa-solid fa-house text-xs" />
            Kembali ke Beranda
          </a>
        </div>
      </div>
    </div>
  );
}
